import * as React from "react";
const SvgChewronRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#000000", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.59003 16.34L13.17 11.75L8.59003 7.16L10 5.75L16 11.75L10 17.75L8.59003 16.34Z" }));
export default SvgChewronRight;
